// ================================
// COLLECTION FILTER SCRIPT (CLEAN VERSION)
// ================================

// ---- Toggle filter groups (mobile vs desktop) ----
function toggleFilterGroups() {
  const deviceSize = window.innerWidth;

  document.querySelectorAll('.filter-button').forEach(button => {
    const dropdown = button.closest('.filter-dropdown');
    const optionName = dropdown?.dataset.optionName?.toLowerCase();
    if (!optionName) return;

    document.querySelectorAll('.filter-group__heading').forEach(sidebarList => {
      const headingText = sidebarList.textContent.trim().toLowerCase();
      const filterGroup = sidebarList.closest('.filter-group');
      if (!filterGroup) return;

      if (headingText.includes(optionName)) {
        if (deviceSize >= 700) {
          // Hide matching filter group on desktop
          filterGroup.style.display = 'none';

          // Always show "Type" & "Color" dropdowns on desktop
          if (optionName === 'type' || optionName === 'color') {
            document.querySelector(`.filter-dropdown[data-option-name="Type"]`)?.style.setProperty('display', 'block');
            document.querySelector(`.filter-dropdown[data-option-name="Color"]`)?.style.setProperty('display', 'block');
          }
        } else {
          // Show filter group on mobile
          filterGroup.style.display = 'block';

          // Hide "Type" & "Color" dropdowns on mobile
          if (optionName === 'type' || optionName === 'color') {
            document.querySelector(`.filter-dropdown[data-option-name="Type"]`)?.style.setProperty('display', 'none');
            document.querySelector(`.filter-dropdown[data-option-name="Color"]`)?.style.setProperty('display', 'none');
          }
        }
      }
    });
  });
}

// ---- Update dropdown button label ----
function updateDropdownLabel(optionName) {
  const dropdown = document.querySelector(`.filter-dropdown[data-option-name="${optionName}"]`);
  if (!dropdown) return;

  const button = dropdown.querySelector('.filter-button');
  const inputs = dropdown.querySelectorAll('.filter-options li input:checked');
  const checkedValues = Array.from(inputs).map(inp => inp.value.trim());
  const isColorFilter = optionName.toLowerCase().includes('color');

  if (checkedValues.length > 0) {
    button.classList.add('active');
    let displayHTML = '';

    if (isColorFilter) {
      displayHTML = checkedValues
        .slice(0, 3)
        .map(color => {
          const colorValue = color.replace(/\s+/g, '-').toLowerCase();
          return `
            <span class="color-swatch swatches" style="--swatch: var(--${colorValue});"></span>
            ${color.toUpperCase()}
          `;
        })
        .join(', ');
      if (checkedValues.length > 3) displayHTML += `<span class="more">...</span>`;
    } else {
      displayHTML = checkedValues.slice(0, 3).join(', ').toUpperCase();
      if (checkedValues.length > 3) displayHTML += ', ...';
    }

    button.innerHTML = `
      ${displayHTML}
      <svg class="filter-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  } else {
    button.classList.remove('active');
    button.innerHTML = `
      ${optionName.toUpperCase()}
      <svg class="filter-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }
}

// ---- Sync dropdown options with sidebar ----
function syncAllFilterOptions() {
  document.querySelectorAll('.filter-options li input').forEach(input => {
    const dataOption = input.dataset.option;
    const value = input.value;

    const sidebarItem = document.querySelector(
      `.filter-group__content .sidebar__item [data-option="${dataOption}"][value="${value}"]`
    );

    const li = input.closest('li');

    if (!sidebarItem) {
      li.style.display = 'none';
      return;
    } else {
      li.style.display = '';
    }

    if (sidebarItem.closest('li.link--disable')) {
      li.classList.add('link--disabled');
      input.checked = false;
    } else {
      li.classList.remove('link--disabled');
    }

    if (sidebarItem.checked) {
      input.checked = true;
      updateDropdownLabel(dataOption);
    }
  });
  console.log('sync load')
}

// ================================
// DROPDOWN TOGGLE + OBSERVER
// ================================

function initFilterDropdowns() {
  const buttons = document.querySelectorAll('.filter-button');

  if (!buttons.length) return;

  buttons.forEach(button => {
    if (button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    button.addEventListener('click', e => {
      e.preventDefault();
      const dropdown = button.closest('.filter-dropdown');
      if (!dropdown) return;

      dropdown.classList.toggle('open');

      // Close other dropdowns
      document.querySelectorAll('.filter-dropdown.open').forEach(d => {
        if (d !== dropdown) d.classList.remove('open');
      });

      syncAllFilterOptions();
      toggleFilterGroups();
      // Observe open dropdown for dynamic input changes
      if (dropdown.classList.contains('open')) {
        observeDropdownInputs(dropdown);
      } else {
        if (window.dropdownObserver) {
          window.dropdownObserver.disconnect();
          window.dropdownObserver = null;
        }
      }
    });
  });
}

// ---- Observe inputs inside open dropdown ----
function observeDropdownInputs(dropdown) {
  if (window.dropdownObserver) {
    window.dropdownObserver.disconnect();
  }

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        attachInputListeners(dropdown);
      }

      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        const input = mutation.target;
        if (input && input.dataset.option) {
          updateDropdownLabel(input.dataset.option);
        }
      }
    }
  });

  observer.observe(dropdown, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked']
  });

  window.dropdownObserver = observer;
  attachInputListeners(dropdown);
}

// ---- Attach input change listeners ----
function attachInputListeners(container) {
  const inputs = container.querySelectorAll('.filter-options li input');
  inputs.forEach(input => {
    if (input.dataset.bound === 'true') return;
    input.dataset.bound = 'true';

    input.addEventListener('change', e => {
      const selectedValue = e.target.value.trim();
      const selectedOptionName = e.target.dataset.option;

      document.querySelectorAll('.filter-group__heading span').forEach(span => {
        const headingText = span.textContent.trim().toLowerCase();
        if (headingText === selectedOptionName.toLowerCase()) {
          const filterGroup = span.closest('.filter-group');
          const checkbox = filterGroup?.querySelector(
            `.filter-group__body input[type="checkbox"][value="${selectedValue}"]`
          );

          if (checkbox && !checkbox.closest('li')?.classList.contains('list-disabled')) {
            checkbox.click();
          }
        }
      });

      updateDropdownLabel(selectedOptionName);
      syncAllFilterOptions();
      toggleFilterGroups();
    });
  });
}

// ---- Close all dropdowns on outside click ----
document.addEventListener('click', e => {
  if (!e.target.closest('.filter-dropdown')) {
    document.querySelectorAll('.filter-dropdown.open').forEach(d => d.classList.remove('open'));
    if (window.dropdownObserver) {
      window.dropdownObserver.disconnect();
      window.dropdownObserver = null;
    }
  }
});

// ================================
// INIT
// ================================

window.addEventListener('load', () => {
  toggleFilterGroups();
  initFilterDropdowns();
  
  // Initialize labels
  document.querySelectorAll('.filter-dropdown').forEach(dropdown => {
    updateDropdownLabel(dropdown.dataset.optionName);
  });
  syncAllFilterOptions();
});

window.addEventListener('resize', toggleFilterGroups);

// Re-init if dropdowns are re-rendered by AJAX
const globalObserver = new MutationObserver(() => initFilterDropdowns());
globalObserver.observe(document.body, { childList: true, subtree: true });
